<template>
  <v-data-table
    :footer-props="{
      'items-per-page-text': 'Số dữ liệu mỗi trang',
      'items-per-page-options': [10, 20, 50]
    }"
    disable-sort
    :headers="headers"
    :items="debts"
    :loading="loading"
    :items-per-page="itemsPerPage"
    :server-items-length="count"
    @update:page="val => updatePagination('page', val)"
    @update:items-per-page="val => updatePagination('itemsPerPage', val)"
    hide-default-header
    class="table"
  >
    <template v-slot:header>
      <thead>
        <tr>
          <th
            v-for="header in headers"
            :key="header.value"
            :style="{ width: header.width, 'text-align': header.align ? header.align : 'left' }"
          >
            <div class="d-inline-block" v-html="header.text"></div>
          </th>
        </tr>
      </thead>
    </template>
    <template v-slot:no-data>
      <div class="my-12 font-weight-bold">
        <p>Không có dữ liệu</p>
      </div>
    </template>
    <template v-slot:[`body.prepend`]>
      <tr>
        <td colspan="1">
          <SmallSelect
            style="width: 90px"
            placeholder="Chọn NH"
            entity="industries"
            @changeSelect="
              val => {
                selectChange('productIndustry', val)
                searchWithOption({ productIndustry: val })
              }
            "
          />
        </td>
        <td colspan="1">
          <SmallSelect
            style="width: 100px"
            ref="producerSelect"
            placeholder="Chọn NSX"
            entity="producers"
            :params="{ productIndustry: filter.productIndustry }"
            @changeSelect="
              val => {
                selectChange('producer', val)
                searchWithOption({ producer: val })
              }
            "
          />
        </td>
        <td colspan="1">
          <SmallSelect
            style="width: 115px"
            ref="productTypeSelect"
            placeholder="Chọn CH"
            entity="productTypes"
            :params="{ producer: filter.producer, productIndustry: filter.productIndustry }"
            @changeSelect="
              val => {
                selectChange('productType', val)
                searchWithOption({ productType: val })
              }
            "
          />
        </td>
        <td colspan="1">
          <div style="width: 80px"></div>
        </td>
        <td></td>
        <td class="red--text text-right">{{ beautifulMoney(stat) }}</td>
        <td></td>
      </tr>
    </template>
    <template v-slot:[`item.date`]="{ item }">
      {{ formatDateDDMMYYYY(item.date) }}
    </template>
    <template v-slot:[`item.productIndustry`]="{ item }">
      {{ item.productIndustry.name }}
    </template>
    <template v-slot:[`item.producer`]="{ item }">
      {{ item.producer.name }}
    </template>
    <template v-slot:[`item.productType`]="{ item }">
      {{ item.productType.name }}
    </template>
    <template v-slot:[`item.totalDebt`]="{ item }">
      {{ beautifulMoney(item.totalDebt) }}
    </template>
    <template v-slot:[`item.datePay`]="{ item }">
      {{ formatDateDDMMYYYY(item.datePay) || '--' }}
    </template>
  </v-data-table>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import SmallSelect from '../../components/samnec/SmallSelect.vue'
import { formatDateDDMMYYYY } from '@/helpers/date.js'
import { get } from 'lodash'
export default {
  components: { SmallSelect },
  data() {
    return {
      headers: [
        { text: '<div style="width: 90px">Ngành hàng</div>', value: 'productIndustry' },
        { text: '<div style="width: 100px">NSX</div>', value: 'producer' },
        { text: '<div style="width: 115px">Chủng hàng</div>', value: 'productType' },
        { text: '<div style="width: 100px">Đơn nhập</div>', value: 'importOrderCode', align: 'left' },
        {
          text: '<div style="width: 110px"><div>Ngày</div><div>phát sinh công nợ</div></div>',
          value: 'date'
        },
        { text: '<div style="width: 100px; text-align: end">Công nợ</div>', value: 'totalDebt', align: 'end' },
        {
          text: '<div style="width: 110px"><div>Ngày cần</div><div>thanh toán tiền</div></div>',
          value: 'datePay'
        }
      ],
      filter: {
        productIndustry: '',
        producer: '',
        productType: ''
      },
      get,
      loading: false
    }
  },
  computed: mapState({
    debts(state) {
      return state['reportDebt'].items
    },
    count(state) {
      return state['reportDebt'].count
    },
    stat(state) {
      return state['reportDebt'].stats
    },
    itemsPerPage(state) {
      return state['reportDebt'].itemsPerPage
    }
  }),
  methods: {
    ...mapActions({
      setItemsPerPage: 'reportDebt/setItemsPerPage',
      getStats: 'reportDebt/getStats',
      fetchReportDebt: 'reportDebt/fetchItems',
      countReportDebt: 'reportDebt/countItems'
    }),
    formatDateDDMMYYYY: formatDateDDMMYYYY,
    beautifulMoney(m) {
      return m !== null && m !== undefined ? Number(m).toLocaleString('en-US') : '--'
    },
    async updatePagination(type, val) {
      const page = type === 'page' ? val : 1
      const itemsPerPage = type === 'itemsPerPage' ? val : this.itemsPerPage
      await this.fetchReportDebt({
        _start: type === 'itemsPerPage' ? 0 : (page - 1) * itemsPerPage,
        _limit: itemsPerPage,
        ...this.filter
      })
      this.setItemsPerPage(itemsPerPage)
    },
    async searchWithOption() {
      await this.fetchReportDebt({ _start: 0, _limit: this.itemsPerPage, ...this.filter })
      await this.countReportDebt({ ...this.filter })
      await this.getStats({ params: { ...this.filter } })
    },
    selectChange(type, val) {
      if (type === 'productIndustry') {
        this.filter.productIndustry = val
        setTimeout(() => {
          this.$refs.producerSelect.changeItems()
          this.$refs.productTypeSelect.changeItems()
        }, 100)
      }
      if (type === 'producer') {
        this.filter.producer = val
        setTimeout(() => {
          this.$refs.productTypeSelect.changeItems()
        }, 100)
      }
      if (type === 'productType') this.filter.productType = val
    }
  },
  async created() {
    await this.fetchReportDebt({ _start: 0, _limit: 10 })
    await this.countReportDebt()
    await this.getStats()
  }
}
</script>
<style lang="scss" scoped>
.table {
  border: 1px solid #ddd;
  border-radius: 4px;
}
</style>
